import React, { useEffect, useState, useRef } from 'react';
import { get } from '../../utils/api';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { isMobile } from '../../config';
import style from './PrdSideBannerComp.module.css';
import { Offcanvas } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import { minIcon, plusIcon, homeIcon, recIcon } from '../../assets/images/product/prodImages';

const ProdSdBnComp = ({ location }) => {

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [data, setData] = useState([]);
    const [expandCate, setExpandCate] = useState(null);
    const [div1Name, setDiv1Name] = useState("");
    const [div2Name, setDiv2Name] = useState("");
    const [show, setShow] = useState(false);
    const [clickedCategory, setClickedCategory] = useState(null);

    const leftPaneRef = useRef(null);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const listIdx = parseInt(searchParams.get("list"));
  
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [location]);

    useEffect(() => {
        const prdSideData = async() => {
            try{
                const res = await get('/product/prdside');
                setData(res);
            } catch(err) {
                console.log(err);
            };
        };

        prdSideData();
    }, []);
    
    useEffect(() => {
        data.forEach((cate) => {
          if ((listIdx === 1 && cate.DIV_1_SEQ === 1) || (listIdx === 52 && cate.DIV_1_SEQ === 8)) {
            setDiv1Name(cate.DIV_1_NAME);
            setDiv2Name("");
            setExpandCate(null);
        } else {
            cate.DIV_2.split(', ').forEach((item) => {
              const [seq, name] = item.replace(/[{}]/g, '').split(':');
              if (parseInt(seq) === listIdx) {
                setDiv1Name(cate.DIV_1_NAME);
                setDiv2Name(name.trim());
                setExpandCate(cate.DIV_1_SEQ);
              }
            });
          }
        });
    }, [listIdx, data]);

    const handleCategoryClick = (id) => {
        if (id === 1) {
          navigate('/product/list?list=1&pageIdx=1');
        } else if(id === 8) {
          navigate('/product/list?list=52&pageIdx=1');
        } else {
            if (isMobile()) {
                setClickedCategory(id);
                handleShow();
                setTimeout(() => {
                    const element = document.getElementById(`cate-${id}`);
                    if (element) {
                        element.scrollIntoView({ behavior: 'smooth' });
                    }
                }, 300);
            } else {
                setExpandCate(expandCate === id ? null : id);
            }
        }
    };
    
    const showData = (data) => {
        return (
            <>
              {data.map((cate) => (
                <div key={cate.DIV_1_SEQ}>
                  <div
                    onClick={() => handleCategoryClick(cate.DIV_1_SEQ)}
                    className={style.subList}
                  >
                    <a
                      className={ (listIdx === 1 && cate.DIV_1_SEQ === 1) || (listIdx === 52 && cate.DIV_1_SEQ === 8) ? style.clickedLink : expandCate === cate.DIV_1_SEQ ? style.activeLink: ''}
                    >
                      {cate.DIV_1_NAME}
                      {(cate.DIV_1_SEQ !== 1 && cate.DIV_1_SEQ !== 8 ) && (
                        <img
                          src={expandCate === cate.DIV_1_SEQ ? minIcon : plusIcon}
                          alt="icon"
                        />
                      )}
                    </a>
                    {expandCate === cate.DIV_1_SEQ && (cate.DIV_1_SEQ !== 1 && cate.DIV_1_SEQ !== 8) && (
                    <div className={style.addList}>
                      {cate.DIV_2.split(', ').map((item) => {
                        const [seq, name] = item.replace(/[{}]/g, '').split(':');
                        return (
                          <Link
                            key={seq}
                            to={`/product/list?list=${seq}&pageIdx=1`}
                            className={parseInt(seq) === listIdx ? style.currentPageLink : ''}
                          >
                            {name.trim()}
                          </Link>
                        );
                      })}
                    </div>
                    )}
                  </div>
                </div>
              ))}
            </>
        );
    };

    const showMobileData = (data) => {
        const handleScrollToView = (div1Seq) => {
            const element = document.getElementById(`cate-${div1Seq}`);
            if (div1Seq === 1) {
                navigate('/product/list?list=1&pageIdx=1');
                handleClose();
            } else if (div1Seq === 8) {
                navigate('/product/list?list=52&pageIdx=1');
                handleClose();
            } else {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        };
        
        return (
            <>
            {data.map((cate) => (
                <div
                    key={cate.DIV_1_SEQ}
                    className={div1Name === cate.DIV_1_NAME ? style.curMenu : style.sideMenu}
                    onClick={() => handleCategoryClick(cate.DIV_1_SEQ)}
                >
                    <a>{cate.DIV_1_NAME}</a>
                </div>
            ))}
            <Offcanvas show={show} onHide={handleClose} placement="bottom" className={style.offCanvas}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title className={style.canTitle}>PRODUCT</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                <div className={style.canvasBody} ref={leftPaneRef}>
                    <div className={style.leftPane}>
                        {data.map((cate) => (
                            <div
                                key={cate.DIV_1_SEQ}
                                className={`${style.leftMenu} ${clickedCategory === cate.DIV_1_SEQ ? style.clickMenu : ''}`}
                                onClick={() => {
                                    setClickedCategory(cate.DIV_1_SEQ);
                                    handleScrollToView(cate.DIV_1_SEQ);
                                }}
                            >
                                <a>{cate.DIV_1_NAME}</a>
                            </div>
                        ))}
                    </div>
                    <div className={style.rightPane}>
                        {data.map((cate) => (
                            <div key={cate.DIV_1_SEQ} id={`cate-${cate.DIV_1_SEQ}`} className={style.cateDiv}>
                                <div className={style.cateTitle}>{cate.DIV_1_NAME}</div>
                                {(cate.DIV_1_SEQ !== 1 && cate.DIV_1_SEQ !== 8) && (
                                <div className={style.cateItems}>
                                    {cate.DIV_2.split(', ').map((item) => {
                                        const [seq, name] = item.replace(/[{}]/g, '').split(':');
                                        return (
                                            <Link
                                                key={seq}
                                                to={`/product/list?list=${seq}&pageIdx=1`}
                                                onClick={handleClose}
                                                className={parseInt(seq) === listIdx ? style.currentPageLink : ''}
                                            >
                                                {name.trim()}
                                            </Link>
                                        );
                                    })}
                                </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
                </Offcanvas.Body>
            </Offcanvas>
            </>
        );
    };

    return (
        <div draggable>
            {isMobile() ? (
            <>
                <div className='prod-line-detail'></div>
                <div className={style.mainMenu}>
                    <a>{div1Name} </a>
                    {div2Name && <a>- {div2Name}</a>}
                </div>
                <div className={style.sideDiv}>
                    {showMobileData(data)}
                </div>
            </>
            ) : (
            <>
                <div className="float-left">
                    <div className={style.componentsDiv}>
                        <div className={style.components}>
                            <p className={style.title}>PRODUCT</p>
                            <ul className={style.subDiv}>
                                {showData(data)}
                            </ul>
                        </div>
                    </div>
                </div>
                <div className={style.listMenu}>
                    <div className={style.miniMenu}>
                        <img src={homeIcon} alt='homeIcon'></img>
                        <img src={recIcon} alt='recIcon' className={style.recIcon}></img>
                        <a>PRODUCT</a>
                        <img src={recIcon} alt='recIcon' className={style.recIcon}></img>
                        <a>{div1Name}</a>
                    </div>
                    
                    <div className={style.mainMenu}>
                        <a>{div1Name} </a>
                        {div2Name && <a>- {div2Name}</a>}
                    </div>
                </div>
            </>
            )}
        </div>
    );
};

export default ProdSdBnComp;